<template>
<div>
  <h1>dados pessoais</h1>
  <div class="innerForm">
    <v-text-field :rules="[v => !!v  || 'Este campo é obrigatório']" color="#E46C0A " type="text" placeholder="Nome" :value="name" name="Name"></v-text-field>
    <v-text-field :rules="[v => !!v || 'Este campo é obrigatório']" color="#E46C0A " type="text" placeholder="Sobrenome" :value="lastName" name="LastName"></v-text-field>
    <v-text-field color="#E46C0A " placeholder="Cpf" :value="cpf && hideCpf(cpf)" readonly></v-text-field>
    <v-text-field v-mask="['##/##/####']" v-on:change="update($event)" :rules="[
      v => testDate(v) || 'A data deve ser digitada no formato: dd/mm/aaaa',
      v => !isUnderYearsOld(v, 16) || 'Não é possivel criar um cadastro com menos de 16 anos'
    ]" name="BirthDay" type="text" class="BirthDay" color="#E46C0A " placeholder="Data de Nascimento" :value="birthday && formatDate(birthday)"></v-text-field>
    <div class="div-checkbox" v-if="show1218">
      <input type="checkbox" v-model="auth" name="AuthResponsible" />
      <div class="styled-checkbox" @click="auth = !auth"><Check v-if="auth"/></div>
      <span >Tenho a autorização dos meus responsáveis legais para a realização deste cadastro</span>
      <p class="formError inf" v-if="!auth">Este aceite é obrigatório</p>
    </div>
    <v-text-field  v-mask="['(##) ####-####','(##) #####-####']" :rules="[(v)=> !!v || 'Este campo é obrigatório']" color="#E46C0A " type="tel" name="Phone" placeholder="Telefone" :value="phone"></v-text-field>
  </div> 
</div>
</template>

<script>
import {VTextField} from 'vuetify/lib'
import {mask} from 'vue-the-mask'
import {isUnderYearsOld,formatDate,hideCpf,testDate} from '../helpers/helpers'
import Check from '@/components/svg/Check.vue'
export default {
  name: 'DadosPessoaisForm',
  directives: {mask},
  props: {
      name:{
        type:String,
      },
      lastName:{
        type:String,
      },
      cpf:{
        type:String,
      },
      birthday:{
        type:String,
      },
      phone:{
        type:String,
      },
      authResponsible: {
        type: Boolean
      }
  },
  data() {
    return {
      show1218: false,
      auth: true
    }
  },
  components:{
    VTextField,
    Check,
  },
  methods:{
    update(value) {
      this.show1218 = isUnderYearsOld(value, 18) && !isUnderYearsOld(value, 16);
      let data = {birthday: value };
      this.$emit("update", data);
    },
    isUnderYearsOld,
    formatDate,
    hideCpf,
    testDate,
    checkValue(value){
      if(!document.querySelector(".innerForm input[name='"+value+"'")) return
      return !!document.querySelector(".innerForm input[name='"+value+"'").value
    },
  },
  updated(){
    console.log('updated', this);
    if(this.birthday && document.querySelectorAll('#input-28').length) document.querySelector('#input-28').valueAsDate = new Date(this.birthday)
    let nascimento = document.querySelector('[name="BirthDay"]').value;
    this.show1218 = isUnderYearsOld(nascimento, 18) && !isUnderYearsOld(nascimento, 16);
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/dadosPessoaisForm.scss";
</style>
